export default __webpack_public_path__ + "images/0x0b3f868e0be5597d5db7feb59e1cadbb0fdda50a.png";